<template>
  <div :class="[baseCss, capLine ? `${baseCss}-cap-line` : null, 'text-sm']" :style="{maxWidth: width, width: '100%'}">
    <table-layout :y-align="yAlign" :equal-cells="fixedWidth">
      <slot />
    </table-layout>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Timeline',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('timeline', [])
    }
  },
  props: {
    yAlign: {
      type: String,
      default: 'middle'
    },
    fixedWidth: {
      type: Boolean
    },
    width: {
      type: String
    },
    capLine: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style>
.bcq-timeline .bcq-timeline-item-bar div
{
  left: 50%;
  transform: translateX(-50%);
}

.bcq-timeline .bcq-timeline-item-bar-circle
{
  aspect-ratio: 1/1;
}

.bcq-timeline.bcq-timeline-cap-line .bcq-table-layout-row:last-of-type:not(:only-child) .bcq-timeline-item-bar div,
.bcq-timeline.bcq-timeline-cap-line .bcq-table-layout-row:first-of-type:not(:only-child) .bcq-timeline-item-bar div
{
  height: 50%;
}

.bcq-timeline.bcq-timeline-cap-line .bcq-table-layout-row:first-of-type:not(:only-child) .bcq-timeline-item-bar div
{
  top: 50%;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/timeline/timeline.vue